import getBookingPackageOption from './getBookingPackageOption';

const getBookingAllowAmex = (state, bookingReference) =>
  parseInt(
    getBookingPackageOption(state, bookingReference, 'PAYMENTS_AMEX_ENABLED'),
    10,
  ) === 1;

export default getBookingAllowAmex;
